import { useEffect } from 'react'

import SkapaLoading, { LoadingBall as SkapaLoadingBall } from '@ingka/loading'

import styles from './fullscreen-spinner.module.css'

export function FullscreenSpinner({ show }: { show?: boolean }) {
  useEffect(() => {
    if (show) {
      document.body.classList.add('loading')
    } else {
      document.body.classList.remove('loading')
    }
    return () => {
      document.body.classList.remove('loading')
    }
  }, [show])

  if (!show) return null

  return (
    <SkapaLoading className={styles.spinner} text={''}>
      <SkapaLoadingBall color={'emphasised'} size={'large'} />
    </SkapaLoading>
  )
}
